module.exports = __webpack_public_path__ + "static/media/iconCalendar.4df9347c.svg";